module.exports = __webpack_public_path__ + "static/media/ServiceVolunteer.3ccc8179.webp";